<template>
    <div>

        <el-select
                :id="selectId"
                v-model="selectModel"
                @change="onChange">
            <el-option v-if="showAll" :value="null" label="All dates"></el-option>
            <template v-for="(label, value) in customFields">
                <el-option :value="value" :label="label"></el-option>
            </template>
            <el-option v-for="(date, i) in dates" :value="date.value" :label="date.text" :key="i"></el-option>

        </el-select>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        props: [
            'id',
            'value',
            'showAll',
            'custom', // boolean or object eg {today: 'Today'}
        ],
        created(){
            if (this.id) {
                this.selectId = this.id;
            }
            if (this.custom) {
                if (typeof this.custom !== 'object') {
                    this.customFields = {custom: 'Custom'}
                } else {
                    this.customFields = this.custom
                }
            }
            let threedaysago = moment().subtract(3, 'd');
            let twodaysago = moment().subtract(2, 'd');
            let ystrday = moment().subtract(1, 'd');
            let today = moment();
            let tmrw = moment().add(1, 'd');
            let day2 = moment().add(2, 'd');
            let day3 = moment().add(3, 'd');
            this.dates = [
                {text: threedaysago.format('dddd Do MMM'), value: threedaysago.format('YYYY-MM-DD')},
                {text: twodaysago.format('dddd Do MMM'), value: twodaysago.format('YYYY-MM-DD')},
                {text: ystrday.format('dddd ([Yesterday])'), value: ystrday.format('YYYY-MM-DD')},
                {text: today.format('dddd ([Today])'), value: today.format('YYYY-MM-DD')},
                {text: tmrw.format('dddd ([Tomorrow])'), value: tmrw.format('YYYY-MM-DD')},
                {text: day2.format('dddd Do MMM'), value: day2.format('YYYY-MM-DD')},
                {text: day3.format('dddd Do MMM'), value: day3.format('YYYY-MM-DD')},
            ];
            if (this.value) {
                let found = false
                this.dates.forEach(date => {
                    if (date.value === this.value) {
                        found = true
                    }
                })
                if (found) {
                    this.selectModel = this.value;
                } else {
                    //TODO FIX this, it should also check the this.custom keys/values, since custom can include any value
                    this.selectModel = 'custom'
                }
            } else if (this.value !== null) {
                this.selectModel = this.dates[3].value;
                this.$emit('input', this.selectModel)
                this.$emit('change', this.selectModel)
            }

        },
        data() {
            return {
                dates: [],
                customFields: {},
                selectModel: null,
                selectId: 'select_' + this._uid,
            }
        },
        methods: {
            onChange(){
                this.$emit('input', this.selectModel)
                this.$emit('change', this.selectModel)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Common/RecentDatesSelector.vue